import { Element as SvgElement } from '@svgdotjs/svg.js';

import { ClickInfo, DragInfo, DragSensor } from '../image-cropper/drag-sensor';

export interface Position {
  x: number;
  y: number;
}

export interface Placement {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  rotation?: number;
}

export interface HandleBehavior {
  respondToDragBegin(element: SvgElement, pointer: Position): void;
  placementAt(element: SvgElement, pointer: Position): Placement;
}

export class Handle
{
  private sensor: DragSensor | undefined = undefined;
  private control: SvgElement | HTMLElement | undefined = undefined;
  public isEnabled: boolean = true;

  public onRequestUpdate: (place: Placement) => void = () => {};
  public onDragEnd: () => void = () => {};
  public onClick: (click: ClickInfo) => void = () => {};

  constructor(
    private element: SvgElement,
    private behavior: HandleBehavior)
  { }

  public applyControl(control: SvgElement | HTMLElement | undefined): void
  {
    if (control === this.control) {
      return;
    }

    this.teardown();
    this.control = control;

    if (!control) {
      return;
    }

    this.sensor = new DragSensor(control);
    this.sensor.onDragBegin = (info: DragInfo) =>
        this.behavior.respondToDragBegin(this.element, info.firstPosition);
    this.sensor.onDrag = (info: DragInfo) => {
      if (!this.isEnabled) {
        return;
      }

      const place = this.behavior.placementAt(this.element, {
        x: info.firstPosition.x + info.delta.x,
        y: info.firstPosition.y + info.delta.y,
      });
      window.requestAnimationFrame(() => this.onRequestUpdate(place));
    };
    this.sensor.onDragEnd = () => {
      if (this.isEnabled) {
        window.requestAnimationFrame(this.onDragEnd);
      }
    };
    this.sensor.onClick = (click: ClickInfo) => this.onClick(click);
  }

  public teardown(): void
  {
    if (this.sensor) {
      this.sensor.destructor();
      this.sensor = undefined;
    }
    this.control = undefined;
  }
}
